import { render, staticRenderFns } from "./CheckTableBodyItem.vue?vue&type=template&id=85ed98e4&scoped=true&"
import script from "./CheckTableBodyItem.vue?vue&type=script&lang=js&"
export * from "./CheckTableBodyItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckTableBodyItem.vue?vue&type=style&index=0&id=85ed98e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ed98e4",
  null
  
)

export default component.exports